import style from "./calculator.module.css";
import { useState, useRef, useEffect, useContext } from "react";
import Confirm from "../Modal/Confirm";
import Loading from "../Modal/Loading";
import { Context } from "../../App";
import { useNavigate } from "react-router";
import { parseBrazilianNumber, IsNumber } from "../../utils/calculator/formatNumberValidator";
import EditableMarket from "./widgets/EditableMarket";
import { EditableTitleEvent } from "./widgets/EditableEventTitle";
import { EditableSubTitleEvent } from "./widgets/EditableSubTitleEvent";
import { EditableProtectionGame } from "./widgets/EditableProtectionGame";
import { EditableCalendar } from "./widgets/EditableCalendar";
import { EditableLink } from "./widgets/EditableLink";
import { FormulaModeSelect } from "./widgets/FormulaModeSelect";
import { FormulaSelector } from "./widgets/FormulaSelector";
import { EditableBonus } from "./widgets/EditableBonus";
import { EditableLockedValue } from "./widgets/EditableLockedValue";
import { calcSurebetBonusFromBets, calcNormalSurebet, stakeChanger, riskFreeBettingFormula, surebetLockedValueFormula } from "../../utils/calculator/formulas";
import { prepareForDataBetForDb } from "../../utils/calculator/prepareDataForDb";
import { updateOperationByPartLink, deleteOperationByPartLink } from "../../api/calculator/calculatorServices";
import { TooltipError } from "./widgets/TooltipError";
function useContinuousChange(onChange, delay = 100) {
  const intervalRef = useRef(null);
  const start = (index, field, valueToIncrement) => {
    intervalRef.current = window.setInterval(() => {
      onChange(index, field, valueToIncrement);
    }, delay);
  };
  const stop = () => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  return { start, stop };
}
function Editor(props) {
  const {
    dataOperation,
    setDataOperation,
    formData,
    setFormData,
    typeSurebet,
    setTypeSurebet,
    idUrlPath,
    settingsCalculator,
    bonusValue,
    setBonusValue,
    bonusProportionValue,
    setBonusProportionValue
  } = props;
  const { statusMode } = useContext(Context);
  const [show, setShow] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [message, setMessage] = useState("");
  const [iconToShow, setIconToShow] = useState("");
  const [itemCount, setItemCount] = useState(dataOperation.length);
  const [budget, setBudget] = useState(0);
  const [roundTo, setRoundTo] = useState(1);
  const [roundingEnabled, setRoundingEnabled] = useState(false);
  const [profitSurebet, setProfitSurebet] = useState(0);
  const [selectedBookmaker, setSelectedBookmaker] = useState(-99999999);
  const functionCaller = useRef(() => {
  });
  const [editingValues, setEditingValues] = useState({});
  const [editingRoundTo, setEditingRoundTo] = useState(void 0);
  const [valueIsUnacceptable, setValueIsUnacceptable] = useState(false);
  const [lockedValue, setLockedValue] = useState(+dataOperation.reduce((total, item, index) => index >= 2 ? total : item.stake + total, 0).toFixed(2));
  const navigate = useNavigate();
  const indexBookmakerBonus = 0;
  const calculateSurebet = ({ paramBudget = budget, paramRoundTo = roundTo, paramRoundingEnabled = roundingEnabled, paramBookmakers = dataOperation } = {}) => {
    const resultCalcNormalSurebet = calcNormalSurebet(paramBudget, paramRoundTo, paramRoundingEnabled, paramBookmakers);
    setProfitSurebet(resultCalcNormalSurebet["profit"]);
    setDataOperation(resultCalcNormalSurebet["dataOperation"]);
  };
  const stakeChangeNormalSurebet = (index, value, canChangeStake = false, skipUpateBackStake = false, backStake = 0, paramBookmakers = dataOperation, paramSelectedBookmaker = selectedBookmaker, paramRoundingEnabled = roundingEnabled, paramRoundTo = roundTo) => {
    const resultCalcStake = stakeChanger(index, value, paramSelectedBookmaker, paramRoundingEnabled, paramRoundTo, paramBookmakers, canChangeStake, skipUpateBackStake, backStake);
    setBudget(resultCalcStake["budget"]);
    setDataOperation(resultCalcStake["dataOperation"]);
    if (resultCalcStake["canUpdateProfit"] === true) {
      setProfitSurebet(resultCalcStake["profit"]);
    }
  };
  const stakeChangeLockedValue = (index, value, canChangeStake = false, skipUpateBackStake = false, backStake = 0, paramBookmakers = dataOperation, paramRoundingEnabled = roundingEnabled, paramRoundTo = roundTo) => {
    const resultCalcStake = stakeChanger(index, value, index, paramRoundingEnabled, paramRoundTo, paramBookmakers, canChangeStake, skipUpateBackStake, backStake);
    setBudget(resultCalcStake["budget"]);
    setDataOperation(resultCalcStake["dataOperation"]);
    if (resultCalcStake["canUpdateProfit"] === true) {
      setProfitSurebet(resultCalcStake["profit"]);
    }
    if (resultCalcStake["dataOperation"].length >= 2) {
      let stake1 = resultCalcStake["dataOperation"][0]["stake"];
      let stake2 = resultCalcStake["dataOperation"][1]["stake"];
      let newLockedValue = +(stake1 + stake2).toFixed(2);
      setLockedValue(newLockedValue);
    }
  };
  const manageSurebetLockedValueFormula = ({
    paramLockedValue = lockedValue,
    paramBookmakers = dataOperation,
    paramRoundingEnabled = roundingEnabled,
    paramRoundTo = roundTo
  } = {}) => {
    const clonedParamBookmakers = structuredClone(paramBookmakers);
    const resultLockedValueSurebet = surebetLockedValueFormula(paramLockedValue, clonedParamBookmakers, paramRoundingEnabled, paramRoundTo);
    setBudget(resultLockedValueSurebet["budget"]);
    setDataOperation(resultLockedValueSurebet["dataOperation"]);
    if (resultLockedValueSurebet["canUpdateProfit"] === true) {
      setProfitSurebet(resultLockedValueSurebet["profit"]);
    }
  };
  const managerCalcRiskFreeBettingFormula = ({
    value = dataOperation.length > 0 ? dataOperation[0]["stake"] : 0,
    paramBookmakers = dataOperation,
    paramRoundingEnabled = roundingEnabled,
    paramRoundTo = roundTo,
    paramBonusValue = bonusValue,
    paramConversionBonusValue = bonusProportionValue
  } = {}) => {
    let resultRiskFreeBettingFormula = riskFreeBettingFormula(value, paramBookmakers, paramRoundingEnabled, paramRoundTo, paramBonusValue, paramConversionBonusValue);
    setBudget(resultRiskFreeBettingFormula["budget"]);
    setDataOperation(resultRiskFreeBettingFormula["dataOperation"]);
  };
  const managerCalcSurebetPinnedStake = (paramBookmakers) => {
    if (selectedBookmaker >= 0) {
      stakeChangeNormalSurebet(selectedBookmaker, paramBookmakers[selectedBookmaker]["stake"], false, false, 0, paramBookmakers, selectedBookmaker, roundingEnabled, roundTo);
    } else {
      calculateSurebet({ "paramBookmakers": paramBookmakers });
    }
  };
  const handleStakeChange = (index, value, canChangeStake = false, skipUpateBackStake = false, backStake = 0) => {
    if (typeSurebet === "bonus_bookmaker" && index === indexBookmakerBonus) {
      const updated = [...dataOperation];
      updated[indexBookmakerBonus]["stake"] = value;
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: updated });
    } else if (typeSurebet === "risk_free_betting" && index === indexBookmakerBonus) {
      const updated = [...dataOperation];
      updated[indexBookmakerBonus]["stake"] = value;
      managerCalcRiskFreeBettingFormula({ value: updated[indexBookmakerBonus]["stake"], paramBookmakers: updated });
    } else if (typeSurebet === "locked_value" && index >= 0 && index <= 1) {
      stakeChangeLockedValue(index, value, canChangeStake, skipUpateBackStake, backStake);
    } else if (typeSurebet === "") {
      stakeChangeNormalSurebet(index, value, canChangeStake, skipUpateBackStake, backStake);
    }
  };
  const handleChanceChange = (index, value) => {
    const updated = [...dataOperation];
    updated[index]["chance"] = value;
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: updated });
    } else if (typeSurebet === "risk_free_betting") {
      if (updated.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramBookmakers: updated });
      }
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramBookmakers: updated });
    } else if (typeSurebet !== "bonus_bookmaker") {
      managerCalcSurebetPinnedStake(updated);
    }
  };
  const updateField = (index, field, value) => {
    const updated = [...dataOperation];
    updated[index] = {
      ...updated[index],
      [field]: value
    };
    setDataOperation(updated);
  };
  const handleArrowKey = (e, isBlocked, currentValue, update, step = 1) => {
    if (isBlocked) return;
    if (e.key === "ArrowUp") {
      e.preventDefault();
      update(+(currentValue + step).toFixed(2));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      update(+(currentValue - step).toFixed(2));
    }
  };
  function openSubmitModal() {
    if (formData.part_link.length === 0) {
      setShowLoadingModal(true);
      setMessage("Parece que voc\xEA ainda n\xE3o preencheu o link da calculadora. Por favor, adicione o link para continuar.");
      setIconToShow("error");
      return;
    }
    setMessage("Deseja realmente continuar? A atualiza\xE7\xE3o tornar\xE1 esta calculadora vis\xEDvel para todos os usu\xE1rios.");
    setShow(true);
  }
  function openSubmitModalDeleteCalculator() {
    setMessage("Deseja realmente prosseguir? A exclus\xE3o da calculadora n\xE3o pode ser desfeita.");
    setShow(true);
  }
  function processData() {
    let dataOperationToSave = prepareForDataBetForDb(JSON.parse(JSON.stringify(dataOperation)));
    let marketDetailsToSave = { ...formData };
    let dataOperationToSaveModified = dataOperationToSave.map((item, index) => {
      if (index === 0) {
        return item;
      } else if (typeSurebet === "bonus_bookmaker" || typeSurebet === "risk_free_betting") {
        item.block_stake = true;
      } else if (typeSurebet === "locked_value" && index > 1) {
        item.block_stake = true;
      }
      return item;
    });
    let dataToSave = {
      "marketDetails": { ...marketDetailsToSave, type_surebet: typeSurebet, round_is_selected: roundingEnabled, round_value: roundTo, index_bookmaker_selected: ~~selectedBookmaker, bonus_value: bonusValue, bonus_proportion_value: bonusProportionValue },
      "marketOperations": dataOperationToSaveModified
    };
    onUpdateOperation(idUrlPath, dataToSave);
  }
  async function onUpdateOperation(currentPartLink, data) {
    setShowLoadingModal(true);
    setIconToShow("loading");
    setMessage("Por favor, aguarde enquanto criamos a opera\xE7\xE3o\u2026");
    const res = await updateOperationByPartLink(currentPartLink, data);
    if (res.ok && res.data) {
      navigate(`/bonus/calculator/${formData.part_link}/edit`);
      setIconToShow("success");
      setMessage("Tudo certo! A calculadora foi atualizada com sucesso.");
      setDataOperation(res.data.marketOperations);
      setFormData(res.data.marketDetails);
    } else {
      setIconToShow("error");
      if ("message" in res) setMessage(res.message);
      else setMessage("Erro inesperado ao criar opera\xE7\xE3o.");
    }
    return res;
  }
  async function deleteCalculator() {
    setShowLoadingModal(true);
    setIconToShow("loading");
    setMessage("Aguarde um momento enquanto a calculadora est\xE1 sendo removida.");
    const res = await deleteOperationByPartLink(idUrlPath);
    if (res.ok) {
      setIconToShow("success");
      setMessage("Pronto! A calculadora foi removida com sucesso.");
    } else {
      setIconToShow("error");
      setMessage(res.message);
    }
  }
  function calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker = dataOperation, paramRoundTo = roundTo, paramRoundingEnabled = roundingEnabled, skipUpateBackStake = false } = {}) {
    let resultOperationFreeBookmaker = calcSurebetBonusFromBets(dataOperationFreeBookmaker[0]["stake"], dataOperationFreeBookmaker, indexBookmakerBonus, paramRoundTo, paramRoundingEnabled, skipUpateBackStake);
    setDataOperation(resultOperationFreeBookmaker);
    const newBudget = resultOperationFreeBookmaker.reduce(
      (sum, operation, i) => i === indexBookmakerBonus ? sum : sum + operation.stake,
      0
    );
    setBudget(+newBudget.toFixed(2));
  }
  useEffect(() => {
    const roundIsSelectedStored = settingsCalculator.current.roundIsSelected;
    const roundValueStored = settingsCalculator.current.roundValue;
    const indexBookmakerSelectedStored = settingsCalculator.current.indexBookmakerSelected;
    setRoundingEnabled(roundIsSelectedStored);
    setRoundTo(roundValueStored);
    setSelectedBookmaker(indexBookmakerSelectedStored);
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ paramRoundTo: roundValueStored, paramRoundingEnabled: roundIsSelectedStored });
    } else if (typeSurebet === "risk_free_betting") {
      managerCalcRiskFreeBettingFormula({ paramRoundingEnabled: roundIsSelectedStored, paramRoundTo: roundValueStored });
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramRoundingEnabled: roundIsSelectedStored, paramRoundTo: roundValueStored });
    } else if (typeSurebet !== "bonus_bookmaker") {
      if (indexBookmakerSelectedStored >= 0) {
        stakeChangeNormalSurebet(indexBookmakerSelectedStored, dataOperation[indexBookmakerSelectedStored]["stake"], false, false, 0, dataOperation, indexBookmakerSelectedStored, roundIsSelectedStored, roundValueStored);
      } else {
        const newBudget = dataOperation.reduce(
          (sum, operation) => sum + operation.stake,
          0
        );
        setBudget(+newBudget.toFixed(2));
        calculateSurebet({ paramBudget: newBudget, paramRoundTo: roundValueStored, paramRoundingEnabled: roundIsSelectedStored });
      }
    }
  }, []);
  function calcNormalSurebetBudgetAdjusted(paramBookmakers = dataOperation) {
    if (paramBookmakers.length > 0) {
      stakeChangeNormalSurebet(0, paramBookmakers[0].stake, true);
    }
  }
  function startCalcFormulaLay(paramBookmakersFormulaLay, paramTypeSurebet = typeSurebet) {
    setEditingValues({});
    if (paramTypeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: paramBookmakersFormulaLay });
    } else if (paramTypeSurebet === "risk_free_betting") {
      if (paramBookmakersFormulaLay.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramBookmakers: paramBookmakersFormulaLay });
      }
    } else if (paramTypeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramBookmakers: paramBookmakersFormulaLay });
    } else if (paramTypeSurebet !== "bonus_bookmaker") {
      managerCalcSurebetPinnedStake(paramBookmakersFormulaLay);
    }
  }
  const handlerCommission = (index, value) => {
    const updated = [...dataOperation];
    updated[index]["commission"] = value;
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: updated });
    } else if (typeSurebet === "risk_free_betting") {
      if (updated.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramBookmakers: updated });
      }
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramBookmakers: updated });
    } else if (typeSurebet !== "bonus_bookmaker") {
      managerCalcSurebetPinnedStake(updated);
    }
  };
  const handlerBudget = (value) => {
    if (typeSurebet !== "bonus_bookmaker" && typeSurebet !== "risk_free_betting" && typeSurebet !== "locked_value") {
      setBudget(+value.toFixed(2));
      calculateSurebet({ "paramBudget": value });
    }
  };
  const setValueOption = (index, field, value) => {
    if (field === "chance") {
      handleChanceChange(index, value);
    } else if (field === "stake") {
      handleStakeChange(index, value);
    } else if (field === "commission") {
      handlerCommission(index, value);
    } else if (field === "backStake") {
      changeValeuBackStake(index, value);
    } else if (field === "budget") {
      handlerBudget(value);
    }
  };
  const increaseField = (index, field, quantity_increment) => {
    if (field === "budget") {
      let budgetSum = +(budget + quantity_increment).toFixed(2);
      setValueOption(-999, "budget", budgetSum);
      return;
    }
    let valueSum = +(dataOperation[index][field] + quantity_increment).toFixed(2);
    setValueOption(index, field, valueSum);
  };
  const decreaseField = (index, field, quantity_increment) => {
    if (field === "budget") {
      let budgetDecremented = +(budget - quantity_increment).toFixed(2);
      setValueOption(-999, "budget", budgetDecremented);
      return;
    }
    let valueDecremented = +(dataOperation[index][field] - quantity_increment).toFixed(2);
    setValueOption(index, field, valueDecremented);
  };
  function changeValeuBackStake(index, value) {
    let newStakeValue = +(value * (dataOperation[index].chance - 1)).toFixed(2);
    handleStakeChange(index, newStakeValue, false, true, value);
  }
  function changeInputValueBackStake(e, index) {
    const { value } = e.target;
    let backStakeNewValue = parseBrazilianNumber(value, dataOperation[index].backStake);
    if (backStakeNewValue !== dataOperation[index].backStake) {
      changeValeuBackStake(index, backStakeNewValue);
    }
    ;
  }
  const { start: startFieldInc, stop: stopFieldInc } = useContinuousChange(increaseField);
  const { start: startFieldDec, stop: stopFieldDec } = useContinuousChange(decreaseField);
  const handleCheckboxChangeMarketType = (index) => {
    const update = [...dataOperation];
    const newOperation = update.map((bet, i) => {
      if (i !== index) return bet;
      const containsLay = bet.market_event.toLowerCase().includes("lay (contra)");
      let newMarketEvent = bet.market_event.trim();
      if (containsLay) {
        newMarketEvent = newMarketEvent.replace(/\s*lay\s*\(contra\)/gi, "").trim();
      } else {
        newMarketEvent = `${newMarketEvent} Lay (Contra)`.trim();
      }
      return { ...bet, market_event: newMarketEvent };
    });
    startCalcFormulaLay(newOperation);
  };
  const handleInputEdition = (index, field, eventValue) => {
    const key = `${index}-${field}`;
    setEditingValues({ [key]: eventValue });
  };
  function helperInputCommission(e, index, operation) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      const newCommission = parseBrazilianNumber(e.target.value, operation.commission);
      handleInputEdition(index, "commission", value);
      setValueOption(index, "commission", newCommission);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "commission", value);
      setValueOption(index, "commission", 0);
    }
  }
  function helperInputChance(e, index, operation) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      const newChance = parseBrazilianNumber(e.target.value, operation.chance);
      handleInputEdition(index, "chance", value);
      setValueOption(index, "chance", newChance);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "chance", value);
      setValueOption(index, "chance", 0);
    }
  }
  function helperInputStake(e, index, operation) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      const newStake = parseBrazilianNumber(e.target.value, operation.chance);
      handleInputEdition(index, "stake", value);
      setValueOption(index, "stake", newStake);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "stake", value);
      setValueOption(index, "stake", 0);
    }
  }
  function helperInputBackStake(e, index) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      handleInputEdition(index, "backStake", value);
      changeInputValueBackStake(e, index);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "backStake", value);
      changeValeuBackStake(index, 0);
    }
  }
  function helperInputBudget(e) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      let newBudget = parseBrazilianNumber(e.target.value, budget);
      handleInputEdition(-999, "budget", value);
      setValueOption(-999, "budget", newBudget);
    } else if (value === "," || value === ".") {
      handleInputEdition(-999, "budget", value);
      setValueOption(-999, "budget", 0);
    }
  }
  function helperInputRound(e) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      setEditingRoundTo(value);
      setEditingValues({});
      let newRoundTo = parseBrazilianNumber(e.target.value, roundTo);
      setRoundTo(newRoundTo);
      if (typeSurebet === "bonus_bookmaker") {
        calculatreBonusBookmakerAndSurebet({ "paramRoundTo": newRoundTo });
      } else if (typeSurebet === "risk_free_betting") {
        if (dataOperation.length > 0) {
          managerCalcRiskFreeBettingFormula({ paramRoundTo: newRoundTo });
        }
      } else if (typeSurebet === "locked_value") {
        manageSurebetLockedValueFormula({ paramRoundTo: newRoundTo });
      } else {
        if (selectedBookmaker >= 0) {
          stakeChangeNormalSurebet(selectedBookmaker, dataOperation[selectedBookmaker]["stake"], false, false, 0, dataOperation, selectedBookmaker, true, newRoundTo);
        } else {
          calculateSurebet({ "paramRoundTo": newRoundTo });
        }
      }
    } else if (value === "," || value === ".") {
      setEditingRoundTo(value);
      setEditingValues({});
      setRoundTo(0);
      if (typeSurebet === "bonus_bookmaker") {
        calculatreBonusBookmakerAndSurebet({ "paramRoundTo": 0 });
      } else if (typeSurebet === "risk_free_betting") {
        if (dataOperation.length > 0) {
          managerCalcRiskFreeBettingFormula({ paramRoundTo: 0 });
        }
      } else if (typeSurebet === "locked_value") {
        manageSurebetLockedValueFormula({ paramRoundTo: 0 });
      } else {
        if (selectedBookmaker >= 0) {
          stakeChangeNormalSurebet(selectedBookmaker, dataOperation[selectedBookmaker]["stake"], false, false, 0, dataOperation, selectedBookmaker, true, 0);
        } else {
          calculateSurebet({ "paramRoundTo": 0 });
        }
      }
    }
  }
  const helperStartFieldIncrement = (index, field, valueToIncrement = 1) => {
    setEditingValues({});
    startFieldInc(index, field, valueToIncrement);
  };
  const helperStartFieldDecrement = (index, field, valueToIncrement = 1) => {
    setEditingValues({});
    startFieldDec(index, field, valueToIncrement);
  };
  function manageEventInputRoundingEnabled(e) {
    const { checked } = e.target;
    setEditingValues({});
    setRoundingEnabled(checked);
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ "paramRoundingEnabled": checked });
    } else if (typeSurebet === "risk_free_betting") {
      if (dataOperation.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramRoundingEnabled: checked });
      }
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramRoundingEnabled: checked });
    } else {
      if (selectedBookmaker >= 0) {
        stakeChangeNormalSurebet(selectedBookmaker, dataOperation[selectedBookmaker]["stake"], false, false, 0, dataOperation, selectedBookmaker, checked, roundTo);
      } else {
        calculateSurebet({ "paramRoundingEnabled": checked });
      }
    }
  }
  useEffect(() => {
    const hasInvalid = dataOperation.some(
      (bet, index) => {
        const key = `${index}-stake`;
        return bet.chance < 1 || bet.commission < -40 || bet.stake < 0 || bet.backStake < 0 || editingValues[key] !== void 0 && editingValues[key].length === 0;
      }
    ) || budget < 0 || roundTo <= 0;
    if (hasInvalid && !valueIsUnacceptable) {
      setValueIsUnacceptable(true);
    } else if (!hasInvalid && valueIsUnacceptable) {
      setValueIsUnacceptable(false);
    }
  }, [dataOperation, budget, roundTo]);
  return (
        <>
            <div className={`card m-3 shadow ${statusMode ? `${style.calculator_bg_dark} ${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_shadow_container_dark_mode}` : ""} `} style={{ marginTop: "70px" }}>
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>

                            <div>
                                <EditableTitleEvent
                                    formData={formData}
                                    setFormData={setFormData}
                                    statusMode={statusMode}
                                />
                            </div>

                            <div className='mt-2'>
                                <EditableSubTitleEvent
                                    formData={formData}
                                    setFormData={setFormData}
                                    statusMode={statusMode}
                                />
                            </div>

                            <label className='mt-2'>
                                <EditableProtectionGame
                                    statusMode={statusMode}
                                    itemCount={itemCount}
                                    setItemCount={setItemCount}
                                    dataOperation={dataOperation}
                                    typeSurebet={typeSurebet}
                                    calculatreBonusBookmakerAndSurebet={calculatreBonusBookmakerAndSurebet}
                                    calculateSurebet={calculateSurebet}
                                    selectedBookmaker={selectedBookmaker}
                                    setSelectedBookmaker={setSelectedBookmaker}
                                    stakeChangeNormalSurebet={stakeChangeNormalSurebet}
                                    managerCalcRiskFreeBettingFormula={managerCalcRiskFreeBettingFormula}
                                    manageSurebetLockedValueFormula={manageSurebetLockedValueFormula}
                                />
                            </label>
                            <br />
                            <br />
                            <div>
                                <FormulaModeSelect
                                    dataOperation={dataOperation}
                                    typeSurebet={typeSurebet}
                                    setTypeSurebet={setTypeSurebet}
                                    startCalcFormulaLay={startCalcFormulaLay}
                                    statusMode={statusMode}
                                    setItemCount={setItemCount}
                                    setEditingValues={setEditingValues}
                                />
                            </div>

                            <div className='mt-4'>

                                <FormulaSelector
                                    typeSurebet={typeSurebet}
                                    setTypeSurebet={setTypeSurebet}
                                    calculatreBonusBookmakerAndSurebet={calculatreBonusBookmakerAndSurebet}
                                    managerCalcRiskFreeBettingFormula={managerCalcRiskFreeBettingFormula}
                                    calcNormalSurebetBudgetAdjusted={calcNormalSurebetBudgetAdjusted}
                                    manageSurebetLockedValueFormula={manageSurebetLockedValueFormula}
                                />
                            </div>
                        </div>

                        <div className='align-self-start'>
                            {
                                typeSurebet === "risk_free_betting" &&
                                <EditableBonus
                                    statusMode={statusMode}
                                    bonusValue={bonusValue}
                                    setBonusValue={setBonusValue}
                                    bonusProportionValue={bonusProportionValue}
                                    setBonusProportionValue={setBonusProportionValue}
                                    managerCalcRiskFreeBettingFormula={managerCalcRiskFreeBettingFormula}
                                />
                            }


                            {((typeSurebet !== "bonus_bookmaker") && (typeSurebet !== "risk_free_betting")) &&
                                <p id={style.calculator_fs_profit_game} className={` ${profitSurebet > 0 ? "text-success" : profitSurebet < 0 ? "text-danger" : statusMode ? `${style.calculator_text_dark_mode}` : ""} `} >{profitSurebet > 0 ? "+" : ""}{profitSurebet.toFixed(2)}%</p>
                            }

                            {
                                typeSurebet === "locked_value" &&
                                <EditableLockedValue
                                    statusMode={statusMode}
                                    lockedValue={lockedValue}
                                    setLockedValue={setLockedValue}
                                    manageSurebetLockedValueFormula={manageSurebetLockedValueFormula}
                                />
                            }
                        </div>
                    </div>
                    <div className={`row ${style.calculator_row} px-1 py-3`}><div className="col-9"></div></div>
                    <div className={`text-center row ${style.calculator_row} border-bottom ${statusMode ? style.calculator_border_color_dark : ""}`}>
                        <div className="col-6 fw-bold ">Mercado</div>
                        <div className="col-2 fw-bold ">Chance</div>
                        <div className="col fw-bold  d-flex justify-content-center">
                            Aposta
                            <div className={style.calculator_empty_space}></div>
                        </div>
                        <div className="col fw-bold ">Lucro</div>
                    </div>

                    {dataOperation.map((operation, index) => {

                        let blockPerMode = (typeSurebet === "bonus_bookmaker" && indexBookmakerBonus !== index) || (typeSurebet === "risk_free_betting" && indexBookmakerBonus !== index) || (typeSurebet === "locked_value" && index > 1);

                        return (
                            <div className={`row ${style.calculator_row} border-bottom d-flex align-items-center ${statusMode ? style.calculator_border_color_dark : ""}`} key={index}>
                                <div className="col-6 d-flex align-items-center">
                                    <div className="w-25 name-bet-home">
                                        <input
                                            type="text"
                                            value={operation.bet_home_name}
                                            onChange={(e) => updateField(index, "bet_home_name", e.target.value)}
                                            className={`align-self-center form-control  ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}`}
                                        />
                                    </div>

                                    <EditableMarket
                                        operation={operation}
                                        index={index}
                                        updateField={updateField}
                                        startCalcFormulaLay={startCalcFormulaLay}
                                        dataOperation={dataOperation}
                                        handleCheckboxChangeMarketType={handleCheckboxChangeMarketType}
                                    />



                                    <div className="align-items-center w-25 d-flex position-relative">
                                        {
                                            operation.commission < -40 &&
                                            <TooltipError />
                                        }
                                        <input
                                            type='text'
                                            className={`odds align-self-center form-control my-1 
                                            ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""} 
                                            ${operation.commission < -40 ? style.calculator_input_value_invalid : ''}    
                                        `}
                                            placeholder="0.00"
                                            value={editingValues[`${index}-commission`] !== undefined ? String(editingValues[`${index}-commission`]).replace(".", ",") : String(operation.commission).replace(".", ",")}
                                            onChange={(e) => { helperInputCommission(e, index, operation); }}
                                            onKeyDown={(e) =>
                                                handleArrowKey(e, false, operation.commission, (val) => {
                                                    setValueOption(index, "commission", val);
                                                    handleInputEdition(index, "commission", String(val));
                                                }
                                                )
                                            }
                                            style={{ width: "70px" }}
                                        />
                                        <div className="d-flex flex-column">
                                            <button
                                                className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}



                                                onMouseDown={() => { helperStartFieldIncrement(index, "commission"); }}
                                                onMouseUp={stopFieldInc}
                                                onMouseLeave={stopFieldInc}
                                            >
                                                <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                        <g>
                                                            <g id="c105_arrow">
                                                                <path
                                                                    d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                                ></path>
                                                            </g>
                                                            <g id="Capa_1_169_"></g>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </button>
                                            <button className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                                onMouseDown={() => { helperStartFieldDecrement(index, "commission"); }}
                                                onMouseUp={stopFieldDec}
                                                onMouseLeave={stopFieldDec}
                                            >
                                                <div className="w-100 h-100 d-flex justify-conetent-center align-items-center" style={{ rotate: "180deg" }}>
                                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                        <g>
                                                            <g id="c105_arrow">
                                                                <path
                                                                    d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                                ></path>
                                                            </g>
                                                            <g id="Capa_1_169_"></g>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2 d-flex justify-content-center align-items-center fs-5 position-relative">
                                    {
                                        operation.chance < 1 &&
                                        <TooltipError />
                                    }
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={operation.block_chance}
                                        onChange={() => updateField(index, "block_chance", !operation.block_chance)}
                                    />

                                    <input
                                        type='text'
                                        className={`odds align-self-center form-control my-1
                                        ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}
                                        ${operation.chance < 1 ? style.calculator_input_value_invalid : ''}    
                                    `}
                                        placeholder="0.00"
                                        disabled={operation.block_chance}
                                        value={editingValues[`${index}-chance`] !== undefined ? String(editingValues[`${index}-chance`]).replace(".", ",") : String(operation.chance).replace(".", ",")}
                                        onChange={(e) => { helperInputChance(e, index, operation); }}
                                        onKeyDown={(e) =>
                                            handleArrowKey(e, operation.block_chance, operation.chance, (val) => {
                                                setValueOption(index, "chance", val);
                                                handleInputEdition(index, "chance", String(val));
                                            },
                                                0.1
                                            )
                                        }
                                        style={{ width: "70px" }}
                                    />
                                    <div className="d-flex flex-column">
                                        <button
                                            className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}



                                            onMouseDown={() => { helperStartFieldIncrement(index, "chance", 0.1); }}
                                            onMouseUp={stopFieldInc}
                                            onMouseLeave={stopFieldInc}
                                            disabled={operation.block_chance}
                                        >
                                            <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                    <g>
                                                        <g id="c105_arrow">
                                                            <path
                                                                d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                            ></path>
                                                        </g>
                                                        <g id="Capa_1_169_"></g>
                                                    </g>
                                                </svg>
                                            </div>
                                        </button>
                                        <button className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                            onMouseDown={() => { helperStartFieldDecrement(index, "chance", 0.1); }}
                                            onMouseUp={stopFieldDec}
                                            onMouseLeave={stopFieldDec}
                                            disabled={operation.block_chance}
                                        >
                                            <div className="w-100 h-100 d-flex justify-conetent-center align-items-center" style={{ rotate: "180deg" }}>
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                    <g>
                                                        <g id="c105_arrow">
                                                            <path
                                                                d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                            ></path>
                                                        </g>
                                                        <g id="Capa_1_169_"></g>
                                                    </g>
                                                </svg>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-center fs-5 d-flex justify-content-center align-items-center">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={operation.block_stake || blockPerMode}
                                        disabled={blockPerMode}
                                        onChange={() => updateField(index, "block_stake", !operation.block_stake)}
                                    />
                                    <div>
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex align-items-center position-relative">

                                                {
                                                    ((operation.stake < 0 && budget > 0) || (editingValues[`${index}-stake`] !== undefined && editingValues[`${index}-stake`].length === 0))
                                                    &&
                                                    <TooltipError />
                                                }


                                                <input
                                                    type='text'
                                                    className={`qt_money align-self-center form-control my-1
                                                    ${statusMode ? `${style.calculator_border_color_dark}
                                                    ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}
                                                    ${((operation.stake < 0 && budget > 0) || (editingValues[`${index}-stake`] !== undefined && editingValues[`${index}-stake`].length === 0)) ? style.calculator_input_value_invalid : ''}
                                                    ${(typeSurebet === "bonus_bookmaker" && indexBookmakerBonus === index) ? `border border-2  ${style.calculator_border_bonus_surebet}` : ""}
                                                `}
                                                    disabled={operation.block_stake || blockPerMode}
                                                    value={editingValues[`${index}-stake`] !== undefined ? String(editingValues[`${index}-stake`]).replace(".", ",") : String(operation.stake).replace(".", ",")}
                                                    onChange={(e) => { helperInputStake(e, index, operation); }}
                                                    onKeyDown={(e) =>
                                                        handleArrowKey(e, operation.block_stake, operation.stake, (val) => {
                                                            setValueOption(index, "stake", val);
                                                            handleInputEdition(index, "stake", String(val));
                                                        }
                                                        )
                                                    }
                                                    style={{ minWidth: "50px", width: "90px", maxWidth: "140px", padding: "8px", textAlign: "right", resize: "both" }}
                                                />

                                                <div className="d-flex flex-column align-items-center">
                                                    <button
                                                        className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                                        onMouseDown={() => { helperStartFieldIncrement(index, "stake"); }}
                                                        onMouseUp={stopFieldInc}
                                                        onMouseLeave={stopFieldInc}
                                                        disabled={operation.block_stake || blockPerMode}
                                                    >
                                                        <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                                <g>
                                                                    <g id="c105_arrow">
                                                                        <path
                                                                            d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                                        ></path>
                                                                    </g>
                                                                    <g id="Capa_1_169_"></g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                    </button>
                                                    <button
                                                        className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                                        onMouseDown={() => { helperStartFieldDecrement(index, "stake"); }}
                                                        onMouseUp={stopFieldDec}
                                                        onMouseLeave={stopFieldDec}
                                                        disabled={operation.block_stake || blockPerMode}
                                                    >
                                                        <div className="w-100 h-100 d-flex justify-conetent-center align-items-center" style={{ rotate: "180deg" }}>
                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                                <g>
                                                                    <g id="c105_arrow">
                                                                        <path
                                                                            d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                                        ></path>
                                                                    </g>
                                                                    <g id="Capa_1_169_"></g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            operation.market_event.toLowerCase().includes("lay (contra)") &&
                                            <div className="d-flex flex-column align-items-center">
                                                <small className={style.calculator_fs_micro}>Responsabilidade</small>
                                                <div className="d-flex align-items-center">

                                                    <input
                                                        type='text'
                                                        className={`qt_money align-self-center form-control my-1
                                                        ${style.calcularto_bg_success}
                                                        ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode}
                                                        ${style.calculator_bg_dark}` : ""}
                                                        ${operation.backStake < 0 && budget > 0 ? style.calculator_input_value_invalid : ''}
                                                        ${(typeSurebet === "bonus_bookmaker" && indexBookmakerBonus === index) ? `border border-2  ${style.calculator_border_bonus_surebet}` : ""}
                                                        `}
                                                        disabled={operation.block_stake || blockPerMode}
                                                        value={editingValues[`${index}-backStake`] !== undefined ? String(editingValues[`${index}-backStake`]).replace(".", ",") : String(operation.backStake).replace(".", ",")}

                                                        onChange={(e) => { helperInputBackStake(e, index); }}

                                                        onKeyDown={(e) =>
                                                            handleArrowKey(e, operation.block_stake, operation.backStake, (val) => {
                                                                setValueOption(index, "backStake", val);
                                                                handleInputEdition(index, "backStake", String(val));
                                                            }
                                                            )
                                                        }
                                                        style={{ minWidth: "50px", width: "90px", maxWidth: "140px", padding: "8px", textAlign: "right", resize: "both" }}
                                                    />
                                                    <div className="d-flex flex-column align-items-center">
                                                        <button
                                                            className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                                            onMouseDown={() => { helperStartFieldIncrement(index, "backStake"); }}
                                                            onMouseUp={stopFieldInc}
                                                            onMouseLeave={stopFieldInc}
                                                            disabled={operation.block_stake || blockPerMode}
                                                        >
                                                            <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                                    <g>
                                                                        <g id="c105_arrow">
                                                                            <path
                                                                                d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                                            ></path>
                                                                        </g>
                                                                        <g id="Capa_1_169_"></g>
                                                                    </g>
                                                                </svg>
                                                            </div>
                                                        </button>
                                                        <button
                                                            className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                                            onMouseDown={() => { helperStartFieldDecrement(index, "backStake"); }}
                                                            onMouseUp={stopFieldDec}
                                                            onMouseLeave={stopFieldDec}
                                                            disabled={operation.block_stake || blockPerMode}
                                                        >
                                                            <div className="w-100 h-100 d-flex justify-conetent-center align-items-center" style={{ rotate: "180deg" }}>
                                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                                    <g>
                                                                        <g id="c105_arrow">
                                                                            <path
                                                                                d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                                            ></path>
                                                                        </g>
                                                                        <g id="Capa_1_169_"></g>
                                                                    </g>
                                                                </svg>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                <small className={style.calculator_fs_micro}>Aposta a favor</small>
                                            </div>
                                        }
                                    </div>
                                    <div className="form-check ms-3 d-flex align-items-center">

                                        {
                                            ((typeSurebet !== "bonus_bookmaker") && (typeSurebet !== "risk_free_betting") && (typeSurebet !== "locked_value")) &&
                                            <input
                                                className="form-check-input d-block"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="checker_first_home_bet"
                                                checked={selectedBookmaker === index}
                                                onChange={() => { setEditingValues({}); setSelectedBookmaker(index); handleStakeChange(index, operation.stake, true); }}
                                            />
                                        }
                                    </div>


                                </div>
                                <div className="profit col d-flex justify-content-center fs-5">
                                    <p className="m-0 " data-tooltip-id="tooltip_first_home_bet">
                                        {operation.profit !== undefined ? valueIsUnacceptable === true ? "Erro" : operation.profit.toFixed(2) : '0.00'}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                    <div className={`row ${style.calculator_row}`}>
                        <div className="col-8"></div>
                        <div className="col">
                            <div className="d-flex justify-content-center align-items-center fs-5 position-relative">
                                {
                                    budget < 0 &&
                                    <TooltipError />
                                }
                                <input
                                    type='text'
                                    disabled={(typeSurebet === "bonus_bookmaker" || typeSurebet === "risk_free_betting" || typeSurebet === "locked_value")}
                                    id="total_value"
                                    className={`qt_money align-self-center form-control my-1
                                        ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}
                                        ${budget < 0 ? style.calculator_input_value_invalid : ''}
                                    `}
                                    placeholder="0.00"
                                    style={{ minWidth: "50px", width: "90px", maxWidth: "140px", padding: "5px", textAlign: "right", resize: "both" }}
                                    value={editingValues[`-999-budget`] !== undefined ? String(editingValues[`-999-budget`]).replace(".", ",") : String(budget).replace(".", ",")}
                                    onChange={(e) => { helperInputBudget(e); }}
                                    onKeyDown={(e) =>
                                        handleArrowKey(e, false, budget, (val) => {
                                            handleInputEdition(-999, "budget", String(val));
                                            setValueOption(-999, "budget", val);
                                        }
                                        )
                                    }
                                />
                                <div className="d-flex flex-column">
                                    <button className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                        onMouseDown={() => { helperStartFieldIncrement(-999, "budget"); }}
                                        onMouseUp={stopFieldInc}
                                        onMouseLeave={stopFieldInc}
                                        disabled={(typeSurebet === "bonus_bookmaker" || typeSurebet === "risk_free_betting" || typeSurebet === "locked_value")}
                                    >
                                        <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                <g>
                                                    <g id="c105_arrow">
                                                        <path
                                                            d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                        ></path>
                                                    </g>
                                                    <g id="Capa_1_169_"></g>
                                                </g>
                                            </svg>
                                        </div>
                                    </button>
                                    <button className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                                        onMouseDown={() => { helperStartFieldDecrement(-999, "budget"); }}
                                        onMouseUp={stopFieldDec}
                                        onMouseLeave={stopFieldDec}
                                        disabled={(typeSurebet === "bonus_bookmaker" || typeSurebet === "risk_free_betting" || typeSurebet === "locked_value")}
                                    >
                                        <div className="w-100 h-100 d-flex justify-conetent-center align-items-center" style={{ rotate: "180deg" }}>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.77 28.77" xmlSpace="preserve" fill="#505050">
                                                <g>
                                                    <g id="c105_arrow">
                                                        <path
                                                            d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"
                                                        ></path>
                                                    </g>
                                                    <g id="Capa_1_169_"></g>
                                                </g>
                                            </svg>
                                        </div>
                                    </button>
                                </div>
                                <div className="form-check ms-3 d-flex align-items-center">
                                    {
                                        ((typeSurebet !== "bonus_bookmaker") && (typeSurebet !== "risk_free_betting") && (typeSurebet !== "locked_value")) &&
                                        <input
                                            className="form-check-input d-block"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="checker_total"
                                            checked={selectedBookmaker === -999}
                                            onChange={() => { setEditingValues({}); setSelectedBookmaker(-999); calculateSurebet(); }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col"></div>
                    </div>
                    <div className={`card shadow-sm p-2 ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode}` : style.calculator_bg_light}`} style={{ backgroundColor: statusMode ? "rgb(25, 28, 31)" : "" }}>
                        <div className="form-check d-flex justify-content-start align-items-center" style={{ fontSize: "small" }}>
                            <input className="form-check-input me-1 "
                                type="checkbox"
                                id="flexCheckDefault"
                                style={{ minHeight: "15px", minWidth: "15px", fontSize: "0.85vw" }}
                                checked={roundingEnabled}
                                onChange={manageEventInputRoundingEnabled}
                            />
                            <label className="form-check-label me-2 fontSizeSmall" htmlFor="flexCheckDefault">Arredondar aposta até:</label>
                            <div className='position-relative'>
                                <div>
                                    {
                                        roundTo <= 0 &&
                                        <TooltipError />
                                    }
                                </div>
                                <div className="input-group " style={{ width: "120px" }}>

                                    <input
                                        type='text'
                                        className={`form-control h-25
                                        ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}
                                        ${roundTo < 0 ? style.calculator_input_value_invalid : ''}        
                                    `}
                                        placeholder="0,00"
                                        value={editingRoundTo !== undefined ? String(editingRoundTo).replace(".", ",") : String(roundTo).replace(".", ",")}
                                        onChange={(e) => { helperInputRound(e); }}

                                        disabled={!roundingEnabled}
                                    />
                                </div>
                            </div>
                            {
                                /*
                            <div className="form-check px-2 d-flex align-items-center" style={{ width: "200px" }}>
                                <input className="form-check-input position-relative m-0" type="checkbox" id="commission-active" style={{ minHeight: "15px", minWidth: "15px" }} />
                                <label className="form-check-label p-0 ms-2 text-color-dark-mode" htmlFor="commission-active">Mostrar comissões</label>
                            </div>
                            */
                            }
                        </div>
                    </div>




                    <div className='mt-4'>
                        <EditableCalendar
                            formData={formData}
                            setFormData={setFormData}
                        />
                    </div>
                    <div className='d-flex justify-content-between py-3'>
                        <EditableLink
                            formData={formData}
                            setFormData={setFormData}
                            statusMode={statusMode}
                        />

                        <div className='d-flex'>
                            <button type="button" className="btn btn-danger" onClick={() => { functionCaller.current = deleteCalculator; openSubmitModalDeleteCalculator(); }}>Remover</button>
                            <div className="mx-1"></div>
                            <button type="button" className="btn btn-success" onClick={() => { functionCaller.current = processData; openSubmitModal(); }}>Atualizar</button>
                        </div>
                    </div>



                </div>


            </div>
            <Confirm
                messageModal={message}
                show={show}
                setShow={setShow}
                processData={functionCaller.current}
            />

            <Loading
                messageModal={message}
                show={showLoadingModal}
                setShow={setShowLoadingModal}
                iconToShow={iconToShow}
            />
        </>
    );
}
var Editor_default = Editor;
export {
  Editor_default as default
};